import { EnvConfig, PlatformProvider } from '@core';

export const getNewVersionNative = (platformProvider: PlatformProvider, env: EnvConfig): void => {
  if (platformProvider.isAndroid) {
    window.open(env.androidApkUrl, '_blank');
  }

  if (platformProvider.isiOS && env.production) {
    window.open(env.iOSApkUrl, '_blank');
  }
};
